// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/open-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statisticPage {
    padding: 20px;
    height: 100%;
    overflow-y: auto;
    background: #f9f9f6;
}

.statisticPage_header {
    margin-bottom: 24px;
}

.statisticPage_title {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 16px 0;
    color: #1a1a1a;
}

.statisticPage_filters {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.statisticPage_filterBtn {
    padding: 8px 16px;
    border: 1px solid #E4E4E9;
    border-radius: 20px;
    background: white;
    cursor: pointer;
    font-size: 14px;
    color: #71717A;
    transition: all 0.2s ease;
}

.statisticPage_filterBtn:hover {
    border-color: #FFA825;
    color: #FFA825;
}

.statisticPage_filterBtn--active {
    background: #FFA825;
    border-color: #FFA825;
    color: white;
}

.statisticPage_filterBtn--active:hover {
    background: #e89720;
    border-color: #e89720;
    color: white;
}

.statisticPage_customRange {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
}

.statisticPage_dateInput {
    padding: 8px 12px;
    border: 1px solid #E4E4E9;
    border-radius: 8px;
    font-size: 14px;
    color: #1a1a1a;
}

.statisticPage_dateSeparator {
    color: #71717A;
}

.statisticPage_content {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.statisticPage_row {
    display: flex;
    gap: 20px;
}

.statisticPage_widget {
    background: white;
    border: 0.5px solid #E4E4E9;
    border-radius: 12px;
    padding: 20px;
    flex: 1;
    min-height: 200px;
    box-shadow: 0px 4px 12px -3.76017px rgba(8, 8, 10, 0.1);
}

.statisticPage_widget--bubbles {
    flex: 2;
    max-height: 350px;
}

.statisticPage_widget--mostWord {
    flex: 1;
}

.statisticPage_widget--speed,
.statisticPage_widget--volume {
    height: 300px;
}

.statisticPage_widget--silence {
    max-width: 300px;
}

.statisticPage_widgetTitle {
    font-size: 16px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 16px;
    text-align: center;
}

.statisticPage_loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
}

.statisticPage_error {
    text-align: center;
    color: #f44336;
    padding: 40px;
}

.statisticPage_noData {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #71717A;
    font-size: 14px;
}

.statisticPage_empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    color: #71717A;
    font-size: 16px;
}

.statisticPage_silenceWidget {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.statisticPage_silenceTitle {
    font-size: 16px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 16px;
}

.statisticPage_silenceValue {
    font-size: 48px;
    font-weight: 700;
    color: #FFA825;
}

.statisticPage_silenceLabel {
    font-size: 14px;
    color: #71717A;
    margin-top: 8px;
}

.statisticPage_wordStats_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.statisticPage_wordStats_header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
}

.statisticPage_backBtn {
    width: 32px;
    height: 32px;
    border: none;
    background: #f5f5f5;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
}

.statisticPage_backBtn:hover {
    background: #e8e8e8;
}

.statisticPage_backIcon {
    width: 12px;
    height: 12px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transform: rotate(180deg);
}

.statisticPage_wordStats_title {
    font-size: 24px;
    font-weight: 600;
    color: #1a1a1a;
}

.statisticPage_wordStats_subtitle {
    font-size: 14px;
    color: #71717A;
    margin-bottom: 16px;
    text-align: center;
}

@media (max-width: 768px) {
    .statisticPage_row {
        flex-direction: column;
    }
    
    .statisticPage_widget--silence {
        max-width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/statisticPage/StatisticPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,OAAO;IACP,iBAAiB;IACjB,uDAAuD;AAC3D;;AAEA;IACI,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,OAAO;AACX;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAA0D;IAC1D,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".statisticPage {\n    padding: 20px;\n    height: 100%;\n    overflow-y: auto;\n    background: #f9f9f6;\n}\n\n.statisticPage_header {\n    margin-bottom: 24px;\n}\n\n.statisticPage_title {\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0 0 16px 0;\n    color: #1a1a1a;\n}\n\n.statisticPage_filters {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.statisticPage_filterBtn {\n    padding: 8px 16px;\n    border: 1px solid #E4E4E9;\n    border-radius: 20px;\n    background: white;\n    cursor: pointer;\n    font-size: 14px;\n    color: #71717A;\n    transition: all 0.2s ease;\n}\n\n.statisticPage_filterBtn:hover {\n    border-color: #FFA825;\n    color: #FFA825;\n}\n\n.statisticPage_filterBtn--active {\n    background: #FFA825;\n    border-color: #FFA825;\n    color: white;\n}\n\n.statisticPage_filterBtn--active:hover {\n    background: #e89720;\n    border-color: #e89720;\n    color: white;\n}\n\n.statisticPage_customRange {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-top: 12px;\n}\n\n.statisticPage_dateInput {\n    padding: 8px 12px;\n    border: 1px solid #E4E4E9;\n    border-radius: 8px;\n    font-size: 14px;\n    color: #1a1a1a;\n}\n\n.statisticPage_dateSeparator {\n    color: #71717A;\n}\n\n.statisticPage_content {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.statisticPage_row {\n    display: flex;\n    gap: 20px;\n}\n\n.statisticPage_widget {\n    background: white;\n    border: 0.5px solid #E4E4E9;\n    border-radius: 12px;\n    padding: 20px;\n    flex: 1;\n    min-height: 200px;\n    box-shadow: 0px 4px 12px -3.76017px rgba(8, 8, 10, 0.1);\n}\n\n.statisticPage_widget--bubbles {\n    flex: 2;\n    max-height: 350px;\n}\n\n.statisticPage_widget--mostWord {\n    flex: 1;\n}\n\n.statisticPage_widget--speed,\n.statisticPage_widget--volume {\n    height: 300px;\n}\n\n.statisticPage_widget--silence {\n    max-width: 300px;\n}\n\n.statisticPage_widgetTitle {\n    font-size: 16px;\n    font-weight: 500;\n    color: #1a1a1a;\n    margin-bottom: 16px;\n    text-align: center;\n}\n\n.statisticPage_loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 300px;\n}\n\n.statisticPage_error {\n    text-align: center;\n    color: #f44336;\n    padding: 40px;\n}\n\n.statisticPage_noData {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    color: #71717A;\n    font-size: 14px;\n}\n\n.statisticPage_empty {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 300px;\n    color: #71717A;\n    font-size: 16px;\n}\n\n.statisticPage_silenceWidget {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n.statisticPage_silenceTitle {\n    font-size: 16px;\n    font-weight: 500;\n    color: #1a1a1a;\n    margin-bottom: 16px;\n}\n\n.statisticPage_silenceValue {\n    font-size: 48px;\n    font-weight: 700;\n    color: #FFA825;\n}\n\n.statisticPage_silenceLabel {\n    font-size: 14px;\n    color: #71717A;\n    margin-top: 8px;\n}\n\n.statisticPage_wordStats_container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n}\n\n.statisticPage_wordStats_header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 8px;\n}\n\n.statisticPage_backBtn {\n    width: 32px;\n    height: 32px;\n    border: none;\n    background: #f5f5f5;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s ease;\n}\n\n.statisticPage_backBtn:hover {\n    background: #e8e8e8;\n}\n\n.statisticPage_backIcon {\n    width: 12px;\n    height: 12px;\n    background-image: url('../../../../assets/open-arrow.svg');\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    transform: rotate(180deg);\n}\n\n.statisticPage_wordStats_title {\n    font-size: 24px;\n    font-weight: 600;\n    color: #1a1a1a;\n}\n\n.statisticPage_wordStats_subtitle {\n    font-size: 14px;\n    color: #71717A;\n    margin-bottom: 16px;\n    text-align: center;\n}\n\n@media (max-width: 768px) {\n    .statisticPage_row {\n        flex-direction: column;\n    }\n    \n    .statisticPage_widget--silence {\n        max-width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
